export const isKougenClient = ({
  tenantId,
  user,
  beforeDate = new Date("2025-01-31"),
}: {
  tenantId: string;
  user: "client" | "admin" | "management" | undefined;
  beforeDate?: Date;
}) => {
  // console.log("IS KOUGEN CLIENT BEFORE DATE");
  // console.log(beforeDate);
  const now = new Date();
  if (
    tenantId &&
    tenantId.includes("kougen") &&
    user === "client" &&
    now < beforeDate
  ) {
    return true;
  }
  return false;
};
